import {css, html, LitElement} from 'lit';

export class SpecialthanksBannerElement extends LitElement {
    static get styles() {
        return css`
            a, a:hover, a:visited {
                color: var(--link-color,#A89368);
                text-decoration: none;
            }
            a:hover {
                text-decoration: underline;
                color: var(--link-color-hover,#A89368);
            }
            a:visited {
                color: var(--link-color,#A89368);
            }
            img {
                max-width: 100%;
                height: auto;
            }
        `;
    }
    static properties = {
        user_name: { state: true },
        user_banner_url: { state: true },
        user_banner_link: { state: true },
    };


    constructor() {
        super();
        this.user_name = '';
        this.user_banner_url = '';
        this.user_banner_link = '';

        var myRequest = new Request('/api/random/patron', {method: 'GET'});

        fetch(myRequest).then(
            responseData => responseData.json()
        ).then(
            responseData => {
                this.user_name = responseData.user_name;
                this.user_banner_url = responseData.user_banner_url;
                this.user_banner_link = responseData.user_banner_link;
            }
        ).catch(function (e) {
            console.log(e);
        });
    }

    render() {
        return html`
            <p>Special thanks to our <a href="/members/">supporters</a>. Check out the Hall of Fame. <a href="/halloffame/">Hall of Fame</a></p>
            ${this.user_name !== '' ? this.renderCustomerElement() : ``}`;
    }

    renderCustomerElement() {
        return html`
            <p>And in particular, our users who pledge to the highest tier. Like ${this.user_name}!</p>
            ${this.user_banner_link !== '' ? html`<a href="${this.user_banner_link}" target="_blank" rel="noopener noreferrer">${this.renderImg()}</a>` : this.renderImg()}
        `;
    }

    renderImg() {
        if (this.user_banner_url !== '') {
            return html`<img src="${this.user_banner_url}" alt="Patreon image for ${this.user_name}"/>`;
        }

        if (this.user_banner_link !== '') {
            html`Visit ${this.user_name}'s personal link!`;
        }

        return html``;
    }
}

customElements.define('specialthanks-banner', SpecialthanksBannerElement);